import React from 'react';
import { LanguageProvider } from './i18n/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { WhatIfSection } from './components/WhatIfSection';
import { AudienceSection } from './components/AudienceSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FerbyTouchSection } from './components/FerbyTouchSection';
import { ShowcaseGallery } from './components/ShowcaseGallery';
import { CollectionSection } from './components/CollectionSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PromiseSection } from './components/PromiseSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-cream-100 font-sans text-gray-800 selection:bg-lavender-200 selection:text-lavender-900" data-id="element-1">
        <Header data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <ProblemSection data-id="element-5" />
          <WhatIfSection data-id="element-6" />
          <AudienceSection data-id="element-7" />
          <ComparisonSection data-id="element-8" />
          <FerbyTouchSection data-id="element-9" />
          <ShowcaseGallery data-id="element-10" />
          <CollectionSection data-id="element-11" />
          <TestimonialsSection data-id="element-12" />
          <PromiseSection data-id="element-13" />
          <FinalCtaSection data-id="element-14" />
        </main>
        <Footer data-id="element-15" />
        <PurchaseNotifications data-id="element-16" />
      </div>
    </LanguageProvider>;
}